<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        v-spacer
        v-btn.mr-4(color="transparent" icon small @click="showModal = !showModal")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.px-2.pb-2(ref="container")
        v-layout.my-6(v-if="!iframeReady")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        iframe(v-show="iframeReady" :src="link" :width="width" :height="height" frameborder="0" @load="iframeLoadHelper")
</template>

<script>
export default {
  name: 'TypeFormView',
  props: ['open', 'link'],
  data: () => ({
    isReady: false,
    iframeReady: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    width () {
      if (this.isReady) {
        return this.$refs.container.clientWidth - 24
      }
      return 600
    },
    height () {
      return 700
    }
  },
  mounted () {
    this.isReady = true
  },
  methods: {
    iframeLoadHelper () {
      this.iframeReady = true
    }
  }
}
</script>

<style scoped>
.iframe-container {
  position: relative;
}
.input-layout {
  position: absolute;
  height: 600px;
}
</style>